import { FC, SVGProps } from 'react';

const UnassignedChatsIcon: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({
  size = 20,
  color = '#666666',
  height = 24,
  width = 24,
  ...props
}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.698 4.69694C6.05198 3.34296 7.93296 2.49976 10.0004 2.49976C14.1434 2.49976 17.5 5.85634 17.5 9.99934C17.5 12.0668 16.6568 13.9478 15.3028 15.3018"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.2508 16.7623C12.2698 17.2326 11.159 17.5001 9.99959 17.5001C8.40243 17.5001 6.9268 16.9974 5.71065 16.1462C3.7648 14.7922 2.5 12.5463 2.5 10.0005C2.5 8.84109 2.76756 7.73035 3.2378 6.74932V6.74121"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.8578 16.8593L3.13965 3.14111"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.111 11.1098C12.0596 10.6719 12.7244 9.71526 12.7244 8.60451C12.7244 7.08833 11.4921 5.85596 9.97593 5.85596C8.86518 5.85596 7.90847 6.52079 7.47876 7.4775"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.71118 16.145C5.88144 14.8235 7.05706 13.356 9.97584 13.356"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default UnassignedChatsIcon;
